import HookBuilderQuery from '@/hooks/HookBuilderQuery';
import { CommunityService } from '@/services/community';

export const useCommunityId = HookBuilderQuery.noParamsHook(
  ['community'],
  CommunityService.findIdByDomain,
  {
    errorMessage: 'There was an error while fetching the community id',
  },
);

export const useCommunity = HookBuilderQuery.getByIdHook(['community'], CommunityService.findById, {
  errorMessage: 'There was an error while fetching the community',
});
